import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
/* Utils */
import async from '../components/Async'
/* Base */
import DashboardLayout from '../layouts/Dashboard'
import PaymentsFinalPage from '../pages/profile-components/PaymentFinalPage'
// Pages components
const Profile = async(() => import('../pages/Profile'))

// inner pages for users that have membership
const Membership = async(() => import('../pages/Membership'))

const Routes = ({ isPaid, ...props }) => (
  <Router>
    <Switch>
      <DashboardLayout {...props}>
        <Route exact path="/register/" render={props => <Membership {...props} />} />
        <Route path="/register/profile/" render={props => <Profile {...props} />} />
        <Route exact path="/register/success" render={props => <PaymentsFinalPage {...props} />} />
      </DashboardLayout>
    </Switch>
  </Router>
)

const mapStateToProps = state => {
  const { user } = state.registrationReducer
  return {
    isPaid: user?.membership || user?.ticket,
  }
}

Routes.propTypes = {
  isPaid: PropTypes.bool,
}

export default connect(mapStateToProps, null)(Routes)
